import { doLogout } from "actions/authAction";

import { BASE_URL } from "./constant";

const IMPORT_SCHEDULE_URL = "import/jadwal-kapal";
export const IMPORT_SCHEDULE_LOADING = "IMPORT_SCHEDULE_LOADING";
export const IMPORT_SCHEDULE_SUCCESS = "IMPORT_SCHEDULE_SUCCESS";
export const IMPORT_SCHEDULE_ERROR = "IMPORT_SCHEDULE_ERROR";

const importScheduleLoading = (bool) => {
  return {
    type: IMPORT_SCHEDULE_LOADING,
    importScheduleLoading: bool,
  };
};

const importScheduleSuccess = (bool, data) => {
  return {
    type: IMPORT_SCHEDULE_SUCCESS,
    importScheduleSuccess: bool,
    data,
  };
};

const importScheduleError = (bool) => {
  return {
    type: IMPORT_SCHEDULE_ERROR,
    importScheduleError: bool,
  };
};

export function importSchedule(data) {
  return (dispatch) => {
    dispatch(importScheduleLoading(true));
    dispatch(importScheduleSuccess(false, null));
    dispatch(importScheduleError(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + IMPORT_SCHEDULE_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(importScheduleLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dispatch(importScheduleSuccess(true, data));
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(importScheduleError(true));
      });
  };
}
